import a from "./_getNative.js";
import t from "./_root.js";
var r = a, e = t, o = r(e, "DataView"), m = o;
export {
  m as default
};
//# sourceMappingURL=_DataView.js.map
